import React from "react";
import { Navigate } from "react-router-dom";
import usePagination from "src/customHooks/usePagination";
import PageHeader from "src/components/pageHeader";
import Pagination from "src/components/pagination";
import PageLoading from "src/components/pageLoading";
import { useCountUsersReportsQuery, useGetUsersReportsQuery } from "../services/user-report.service";
import UsersReportsTable from "../components/UsersReportsTable";
import { UsersReportsTableSkeleton } from "../components/UsersReportsTableSkeleton";
import { UserReport } from "../types/user-report.entity";

type UserReportWithId = UserReport & { id: string };

const UsersReportsPage: React.FC = () => {
  const {
    data,
    numberOfPages,
    currentPage,
    next,
    prev,
    isSuccess,
    isError,
    isLoading,
    isFetching,
  } = usePagination<UserReportWithId>({
    useGetDataQuery: useGetUsersReportsQuery,
    useCountData: useCountUsersReportsQuery,
  });

  return (
    <div className="page_container">
      <PageHeader text="Users Reports" />
      {isSuccess ? (
        <>
          {isLoading || isFetching ? (
            <div className="overflow-x-auto mb-6 -mx-2 sm:mx-0">
              <table className="min-w-[900px] sm:min-w-full border border-gray-200 divide-y divide-gray-200 text-[11px] sm:text-xs">
                <thead className="bg-gray-900 text-white text-center text-[10px] sm:text-xs">
                  <tr>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Reporter / Reported</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Date</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">From / Reason</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider w-2/5 min-w-[320px]">Explanation</th>
                    <th className="px-2 py-2 sm:px-4 sm:py-3 uppercase tracking-wider">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <UsersReportsTableSkeleton rows={10} />
                </tbody>
              </table>
            </div>
          ) : (
            <UsersReportsTable data={data ?? []} />
          )}
          <Pagination
            numberOfPages={numberOfPages}
            currentPage={currentPage}
            prev={prev}
            next={next}
            isLoading={isLoading || isFetching}
          />
        </>
      ) : isError ? (
        <Navigate to="/505" />
      ) : (
        <PageLoading />
      )}
    </div>
  );
};

export default UsersReportsPage;
